import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Params, Router, UrlTree } from '@angular/router';
import { APPLICATION_NAME_TOKEN, ApplicationName } from '@ddt-web/config';
import { UserPreferencesConfig } from '@ddt-web/data-service';
import { ApplicationNames, SharedApplicationConstants } from '@ddt-web/domain';
import { ApplicationStateStoreProxyService, BpasEngagementsStoreService } from '@ddt-web/shared-stores';
import { StoreService } from '@ddt-web/store-service';
import { UserPreferences } from '@ddt-web/user-data';
import * as cloneDeep from 'lodash/cloneDeep';
import { combineLatest, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

/**
 * Guard to ensure URL is set up correctly for KPI. PC and BPAS differ in where the currency is stored.
 */
@Injectable({
	providedIn: 'root'
})
export class PortfolioEditorGuard implements CanActivate {

	constructor(
		private storeService: StoreService,
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService,
		private router: Router,
		@Inject(APPLICATION_NAME_TOKEN) protected applicationName: ApplicationName,
		private engagementStoreService: BpasEngagementsStoreService
	) { }

	public canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree> | boolean {
		const queryParams: Params = cloneDeep(route?.queryParams);
		const tree = this.router.parseUrl(route.url[0].path);

		if (!queryParams.currency) {
			if (SharedApplicationConstants.PC_APPS.includes(this.applicationName)) {
				return combineLatest([
					this.storeService.selectAll(UserPreferencesConfig.userPreferences).pipe(first(userPreferences => !!userPreferences)),
					this.applicationStateStoreProxyService.getSelectedCurrency()
				]).pipe(map(([userPreferences, analysisStateCurrency]) => {
					tree.queryParams = { ...queryParams, currency: analysisStateCurrency || (userPreferences as UserPreferences).currency };
					return tree;
				}));
			} else if (this.applicationName === ApplicationNames.PORTFOLIO_ANALYSIS_CONSTRUCTION) {
				return this.engagementStoreService.selectCurrentEngagement$().pipe(
					first(engagement => !!engagement),
					map(engagement => {
						tree.queryParams = { ...queryParams, currency: engagement.currency };
						return tree;
					})
				);
			}
		} else {
			return true;
		}
	}
}
